export type Predicate<T> = (value: T) => boolean

export function AND<T>(...predicates: Predicate<T>[]): Predicate<T> {
  return arg => predicates.every(predicate => predicate(arg))
}

export function OR<T>(...predicates: Predicate<T>[]): Predicate<T> {
  return arg => predicates.some(predicate => predicate(arg))
}

export function NOT<T>(predicate: Predicate<T>): Predicate<T> {
  return arg => !predicate(arg)
}

export const TRUE: Predicate<unknown> = () => true
export const FALSE: Predicate<unknown> = () => false
